import { 
    Button, 
    faArrowLeftRotate, 
    FontAwesomeIcon, 
    HashLink, 
    useMediaQuery
} from "../../../../Constants/libraries"
import { 
    title,
    content_first_p1,  
    content_second_title,
    content_second_bullets,
    content_third_p1,

} from "./Constants"
import { CTA } from "../../../CTA/CTA"

import "../../ServicesSubpages.css"
import "./Financial.css"

export const Financial = () => {

    const tablet = useMediaQuery({ query: '(max-width: 780px)' })
    const background = tablet ? "https://smscs-frontend.s3.ap-southeast-1.amazonaws.com/Services/Services_All_Thumbnails_Resized/services_advisor.jpg" : "https://smscs-frontend.s3.ap-southeast-1.amazonaws.com/Services/Services_All_Thumbnail_Backgrounds/services_advisor_background.jpg"
    
    return (
        <>
            <div 
                id=">"
                className="Financial Services__Subpage"
                style={{
                    background: "#000000",
                    backgroundImage: `url(${background})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                }}
            >
                <div className="Services__Subpage__Overlay"></div>

                <div className="Financial__Overwrite Services__Subpage__Overlay-cancel">

                    {/* Content */}
                    {!tablet && 
                        <div className="Services__Subpage__Content">
                            <p>{content_first_p1}</p>
                            <hr />

                            <h1>{content_second_title}</h1>
                            <ul>
                                {content_second_bullets.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                            <hr />

                            <p>{content_third_p1}</p>
                            <hr />
                        </div>
                    }

                    {/* Empty div for flexbox */}
                    <div className="Services__Subpage__Content-flex">
                        <p>{title}</p>
                        <Button>
                            <HashLink smooth to="/services#>">
                                <span><FontAwesomeIcon icon={faArrowLeftRotate}/></span>
                                SERVICES
                            </HashLink>
                        </Button>
                    </div>
                </div>
            </div>

            {/* Content layout for mobile */}
            {tablet && 
                <div className="Services__Subpage__Content">
                    <p>{content_first_p1}</p>
                    <hr />

                    <h1>{content_second_title}</h1>
                    <ul>
                        {content_second_bullets.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                    <hr />

                    <p>{content_third_p1}</p>
                    <hr />
                </div>
            }

            {/* CTA */}
            <CTA />
        </>
    )
}